import { render, staticRenderFns } from "./Ordini.vue?vue&type=template&id=52b66d3a&"
import script from "./Ordini.vue?vue&type=script&lang=js&"
export * from "./Ordini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports